var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconToggle40Hover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(4 11)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5697B7",
    stroke: "#90BACF",
    d: "M24.75,-0.5 C27.1696033,-0.5 29.3637172,0.567199612 30.9513271,2.29913769 C32.5238656,4.01463426 33.5,6.38328932 33.5,9 C33.5,11.6167107 32.5238656,13.9853657 30.9513271,15.7008623 C29.3637172,17.4328004 27.1696033,18.5 24.75,18.5 L24.75,18.5 L8.25,18.5 C5.83039672,18.5 3.63628283,17.4328004 2.04867293,15.7008623 C0.476134402,13.9853657 -0.5,11.6167107 -0.5,9 C-0.5,6.38328932 0.476134402,4.01463426 2.04867293,2.29913769 C3.63628283,0.567199612 5.83039672,-0.5 8.25,-0.5 L8.25,-0.5 L8.25,-0.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.95,14.2 C21.211,14.2 19,11.922 19,9.1 C19,6.278 21.211,4 23.95,4 C26.689,4 28.9,6.278 28.9,9.1 C28.9,11.922 26.689,14.2 23.95,14.2 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggle40Hover);
export default __webpack_public_path__ + "static/media/icon_toggle_40_hover.72ce91abb56ce40bacc994659c91aa6c.svg";
export { ForwardRef as ReactComponent };